import React, { ChangeEvent, useEffect, useState } from 'react';
import { Button, Input } from '@asigna/kit';
import useSafe from 'hooks/use-safe';
import { isUndefined } from 'lodash';
import { TransactionStatus } from 'store/types';

import EditIcon2 from '../../../images/edit_icon2.svg';
import { nextAvailableNonce } from '../../../utils/nonce-tools';

interface NonceInputProps {
  onChange: (val: any) => void;
  onError?: (val: boolean) => void;
  fontClassName?: string;
  // TODO_R: не используется в самом компоненте
  errorText?: string;
  // TODO_R: не используется в самом компоненте
  value?: number | string;
}

// TODO_R: move into uikit
// TODO_R: [FRS]
export const NonceInput = (props: NonceInputProps) => {
  const { onChange, onError, fontClassName = 'text-r14 text-white' } = props;
  const { transactions, nextExecutedNonce } = useSafe();
  const [errorText, setErrorText] = useState('');
  const [alertText, setAlertText] = useState('');
  const [nonceInputShown, setNonceInputShown] = useState(false);
  const [inputValue, setInputValue] = useState('0');
  const [recomendedNonce, setRecomendedNonce] = useState<number>();

  const loadRecomendedNonce = () => {
    setRecomendedNonce(
      nextAvailableNonce(
        transactions.filter(
          (tx) =>
            tx.status === TransactionStatus.QUEUED || tx.status === TransactionStatus.EXECUTION
        ),
        nextExecutedNonce
      )
    );
  };

  useEffect(() => {
    loadRecomendedNonce();
    if (isUndefined(recomendedNonce)) return;
    onChange(recomendedNonce.toString());
    setInputValue(recomendedNonce.toString());
  }, [recomendedNonce]);

  const handleInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    if (!value.match(/[0-9]/) && value !== '') {
      return;
    }
    setErrorText('');
    setAlertText('');
    setInputValue(value.replace(/[^0-9]/g, ''));

    onChange(value);
    if (onError) onError(false);
    const nonceConflictTransaction = transactions.some(
      (transaction) =>
        (transaction.status === TransactionStatus.QUEUED ||
          transaction.status === TransactionStatus.EXECUTION) &&
        transaction.nonce === +value
    );
    if (+value < nextExecutedNonce) {
      setErrorText("Nonce can't be lower than " + nextExecutedNonce);
      onError?.(true);
    } else if (!isUndefined(recomendedNonce) && Number(value) !== recomendedNonce) {
      setAlertText('Recommended nonce is ' + recomendedNonce);
    }
    if (+value >= nextExecutedNonce) {
      setErrorText('');
    }
    if (nonceConflictTransaction && +value >= nextExecutedNonce)
      setAlertText('Using this nonce will create conflict transaction');
  };

  return (
    <>
      {!nonceInputShown ? (
        <div className="flex gap-4 items-center">
          <span className={fontClassName}>Transaction nonce</span>
          <span>{inputValue}</span>
          <Button
            onClick={() => setNonceInputShown(true)}
            className="ml-auto"
            message="Edit"
            rightIcon={EditIcon2}
            size="sm"
            colorType="secondary"
            iconSize={16}
          />
        </div>
      ) : (
        <div className="flex w-full flex-col gap-8">
          <div className={fontClassName}>Transaction nonce</div>
          <Input size="md" value={inputValue} onChange={handleInputChange} />
          {Boolean(errorText) && <div className="text-r13 text-error">{errorText}</div>}
          {Boolean(alertText) && <div className="text-r13 text-primary">{alertText}</div>}
        </div>
      )}
    </>
  );
};
